/**
 * @file コンポーネント：フル動画ページタイムラインイベント DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル設定読み込み
import { StyledEvent, StyledEventText, StyledEventTime } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledEvent>
            {/* イベント時間 */}
            <StyledEventTime>{props.time}</StyledEventTime>
            {/* イベント本文 */}
            <StyledEventText ref={props.refText}>{props.text}</StyledEventText>
        </StyledEvent>
    );
};
